import { useState } from "react";
import { toast } from "sonner";
import { MessageCircle, Loader2 } from "lucide-react";
import { api } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

const Reframer = () => {
  const { user } = useAuth();
  const [mess, setMess] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (mess.trim().length < 5) {
      toast.error("Give it a few more words to work with.");
      return;
    }
    setLoading(true);
    setMessage("");
    try {
      const { data } = await api.post("/ai/reframe", { mess });
      setMessage(data.message);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Reframe failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card-surface p-8" data-testid="reframer">
      <div className="flex items-baseline justify-between mb-2">
        <div className="text-xs uppercase tracking-[0.2em] text-teal-300/80">Mess to Message</div>
        <div className="text-xs text-neutral-500">Reframer</div>
      </div>
      <h3 className="font-display text-2xl text-neutral-100 mb-6">Say the ugly thing out loud.</h3>

      <textarea
        data-testid="reframer-input"
        value={mess}
        onChange={(e) => setMess(e.target.value)}
        placeholder="Type the raw, unfiltered version. Nobody sees this but you."
        rows={5}
        className="wwr-input w-full rounded-xl px-4 py-3 text-sm resize-none"
      />
      <div className="mt-4 flex items-center justify-between">
        <span className="text-xs text-neutral-500">{mess.length}/2000</span>
        <button
          onClick={submit}
          disabled={loading}
          data-testid="reframer-submit-btn"
          className="btn-primary px-5 py-2.5 inline-flex items-center gap-2 disabled:opacity-60"
        >
          {loading ? <Loader2 size={16} className="animate-spin" /> : <MessageCircle size={16} />}
          {loading ? "Listening…" : "Reframe"}
        </button>
      </div>

      {message && (
        <div data-testid="reframer-output" className="mt-6 rounded-xl border border-teal-500/25 bg-teal-500/5 p-5">
          <div className="text-xs uppercase tracking-widest text-teal-300/80 mb-2">The reframe</div>
          <p className="text-neutral-100 leading-relaxed whitespace-pre-line">{message}</p>
          {!user && (
            <p className="text-xs text-neutral-500 mt-4">Sign up to save this reframe.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default Reframer;
